import { render, staticRenderFns } from "./VerifyIdentityExternal.vue?vue&type=template&id=1eeda5d4&"
import script from "./VerifyIdentityExternal.vue?vue&type=script&lang=js&"
export * from "./VerifyIdentityExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eeda5d4')) {
      api.createRecord('1eeda5d4', component.options)
    } else {
      api.reload('1eeda5d4', component.options)
    }
    module.hot.accept("./VerifyIdentityExternal.vue?vue&type=template&id=1eeda5d4&", function () {
      api.rerender('1eeda5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/eSign/components/VerifyIdentityExternal.vue"
export default component.exports